







import { Component, Vue } from "vue-property-decorator";

/**
 * Small grey footnote explaining the "*" marker that KpiCards / SelectedExposurePanel
 * append to scenario-window metrics. Shown at the bottom of the tabs that surface those
 * metrics (Overview, Daily Map).
 */
@Component
export default class ScenarioWindowFootnote extends Vue {}
